import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { Link, useParams } from 'react-router-dom'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import { useEffect, useRef } from 'react'
import { ClassDetails } from './ClassDetails'
import HelmetMeta from '../../layouts/HelmetMeta'

export default function ClassesAbuDhabi () {
  const { article } = useParams()
  const readingRef = useRef(null)

  useEffect(() => {
    if (article) {
      setTimeout(() => readingRef.current.scrollIntoView(), 100)
    }
  }, [article])

  return (
    <Container>
      <HelmetMeta
        title='EMIRATES SKATING CLUB | Ice Skating Classes in Abu Dhabi'
        description='Whether you are looking to perfect your technique or simply enjoy a leisurely skate, join Emirates Skating Club classes in Abu Dhabi!'
      />
      <Box sx={{ pt: 14, pb: 2 }}>
        <Typography variant='h5' component='h1'>SCHEDULE OF CLASSES AT ESC ABU DHABI</Typography>
      </Box>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12 }}>
          <Typography variant='subtitle2'>
            At the Emirates Skating Club in Abu Dhabi, ice-skating becomes an exhilarating escape from the desert heat. This premier facility boasts a modern ice rink where skaters can glide effortlessly in a cool, crisp environment. Catering to both recreational and competitive skaters, the club offers a range of programs from beginner lessons to advanced training sessions. Whether you are looking to perfect your technique or simply enjoy a leisurely skate, the Emirates Skating Club provides a vibrant and welcoming atmosphere for all ages.
          </Typography>
          <Box sx={{ mt: 2 }} ref={readingRef}>
            <Button variant='contained' component={Link} to='/team/abu-dhabi/ice-team' target='_blank'>Coaches</Button>
            <Button variant='contained' sx={{ ml: 2 }} component={Link} to='/locations' target='_blank'>Location</Button>
          </Box>
        </Grid>
        <ClassDetails />
      </Grid>
    </Container>
  )
}
